import React, { useEffect, useRef } from 'react';

import { ensureTrustpilotBootstrap } from './ensureTrustpilotBootstrap';

const BUSINESS_UNIT_ID = '60c847b7f033d300019ff3a1';
const TEMPLATE_ID = '539adbd6dec7e10e686debee';
const TOKEN = '4393445e-a704-447c-b031-953258470511';

/**
 * Trustpilot 官方 TrustBox：Grid（评价网格）
 * bootstrap 由组件内部加载，页面无需再写 script
 */
const TrustpilotGrid: React.FC<{
  className?: string;
}> = ({ className }) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    let cancelled = false;

    ensureTrustpilotBootstrap()
      .then(() => {
        if (!cancelled && ref.current && window.Trustpilot) {
          window.Trustpilot.loadFromElement(ref.current, true);
        }
      })
      .catch(() => {
        // bootstrap 加载失败时保留占位链接，不阻断页面
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className={className}>
      <div
        ref={ref}
        className="trustpilot-widget"
        data-locale="en-US"
        data-template-id={TEMPLATE_ID}
        data-businessunit-id={BUSINESS_UNIT_ID}
        data-style-height="700px"
        data-style-width="100%"
        data-token={TOKEN}
        data-tags="overallexperience"
        data-stars="5"
        data-review-languages="en"
        data-text-color="#1B1F4D">
        <a
          href="https://www.trustpilot.com/review/wukongsch.com"
          target="_blank"
          rel="noopener">
          Trustpilot
        </a>
      </div>
    </div>
  );
};

export default TrustpilotGrid;
